module.exports = __webpack_public_path__ + "img/5-2.1b416f03.svg";